export default __webpack_public_path__ + "static/media/become-a-mentor.df6de833.webp";